var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Datetime, DatetimeFormat } from '../..';
import { reduceRatio } from '../../util-components/aspect-ratio';
import { PlatformName } from '../../util-components/platform-name';
import DeviceIcon from '../device-icon';
import { devicesList } from '../device-icon/devices-list';
import ScreenState from '../screen-state';
import { Styled } from './style';
var DeviceInfo = /** @class */ (function (_super) {
    __extends(DeviceInfo, _super);
    function DeviceInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeviceInfo.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height, model = _a.model, platform = _a.platform, status = _a.status;
        var matchIcon = devicesList.filter(function (device) { return device.model === model; });
        var deviceName = (matchIcon.length && matchIcon[0].name) || model;
        var platformName = PlatformName(platform ? platform : 'Unknown Platform');
        // ScreenCloud OS specific
        if (platform === 'linux' && model === 'firep1') {
            platformName = 'ScreenCloud OS';
        }
        return (React.createElement(Styled, null,
            React.createElement("div", { className: "icon" },
                React.createElement(DeviceIcon, { model: model, platform: platform })),
            React.createElement("div", { className: "detail" },
                React.createElement(ScreenState, { status: status }),
                React.createElement("h5", null, deviceName || 'Unknown Device'),
                React.createElement("p", null, platformName),
                width && height && (React.createElement("p", null,
                    width,
                    " x ",
                    height,
                    ", ",
                    reduceRatio(width, height)))),
            React.createElement("p", { className: "device-note" },
                React.createElement(FormattedMessage, { id: "ui_component.device_info.connected_since", defaultMessage: "Connected since {date_string}", values: {
                        date_string: React.createElement(Datetime, { value: this.props.createdAt, format: DatetimeFormat.ShortWithRelative }),
                    } }))));
    };
    return DeviceInfo;
}(React.Component));
export default DeviceInfo;
//# sourceMappingURL=index.js.map